import React, { useContext, useEffect, useState } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import api from "../../../services/api";
import ActionTable from "../../../components/table/ActionTable";
import Form from "../../../components/form";

export default function Instituicao(props) {
  const [instituicaoId] = useState(Number(props.match.params.id));
  const [escola, setEscola] = useState({});
  const [nomeBusca, setNomeBusca] = useState("");
  const [escolas, setEscolas] = useState([]);
  const [instituicaoImportar, setInstituicaoImportar] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (instituicaoId > 0) {
      carregarInstituicao();
    }
  }, []);

  const carregarInstituicao = () => {
    cfe
      .get("admin/instituicoes/carregar", { id: instituicaoId })
      .then((res) => {
        setEscola(res);
      })
      .catch((e) => notification("error", "Erro ao listar os intituição"));
  };

  const buscarInstuicaoImportar = (escolaBuscar) => {
    setNomeBusca(escolaBuscar.nome);
    api
      .get("escolas/listar", escolaBuscar)
      .then((escolasBusca) => {
        if (escolasBusca.length === 0)
          notification("warning", "Nenhuma escola localizada.");

        escolasBusca.forEach((e) => (e.local = `${e.municipio} - ${e.UF}`));

        setEscolas(escolasBusca);
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao listar as escolas.");
      });
  };

  const fBuscaEscola = {
    title: "Buscar escola (Bilíngue)",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: nomeBusca,
      },
    },
    submit: {
      label: "Buscar",
      action: buscarInstuicaoImportar,
    },
    close: true,
    history: props.history,
  };

  const salvar = (formulario) => {
    const instituicaoSalvar = formulario;
    instituicaoSalvar.id = escola.id;
    instituicaoSalvar.tituloConfiguracoesAcesso =
      escola.tituloConfiguracoesAcesso;
    instituicaoSalvar.tituloParametrosCobranca = "";
    instituicaoSalvar.tituloEndereco = "";

    cfe
      .post("admin/instituicoes/editar", instituicaoSalvar)
      .then(() => {
        notification("success", "Dados salvos!");

        props.history.goBack();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao salvar os dados.");
      });
  };

  const fInstituicao = {
    title: "Instituição",
    form: {
      nomeFantasia: {
        label: "Nome fantasia",
        type: "text",
        value: escola.nomeFantasia,
        required: true,
        space: 6,
      },
      razaoSocial: {
        label: "Razão social",
        type: "text",
        value: escola.nomeFantasia,
        required: true,
        space: 6,
      },
      CNPJ: {
        label: "CNPJ",
        type: "text",
        value: escola.CNPJ,
        space: 6,
      },
      emailFinanceiro: {
        label: "Email financeiro",
        type: "text",
        value: escola.emailFinanceiro,
        required: true,
        space: 6,
      },
      tituloEndereco: {
        type: "component",
        value: (
          <h3
            style={{
              marginTop: 20,
              marginBot: 10,
              textDecoration: "underline",
            }}
          >
            Endereço
          </h3>
        ),
      },
      enderecoCEP: {
        label: "CEP",
        type: "text",
        value: escola.enderecoCEP,
        space: 4,
      },
      enderecoRua: {
        label: "Logradouro",
        type: "text",
        value: escola.enderecoLogradouro,
        space: 6,
      },
      enderecoNumero: {
        label: "Número",
        type: "text",
        value: escola.enderecoNumero,
        space: 2,
      },
      enderecoBairro: {
        label: "Bairro",
        type: "text",
        value: escola.enderecoBairro,
        space: 4,
      },
      enderecoMunicipio: {
        label: "Município",
        type: "text",
        value: escola.enderecoMunicipio,
        space: 6,
      },
      enderecoUF: {
        label: "UF",
        type: "text",
        value: escola.enderecoUF,
        space: 2,
      },
      tituloParametrosCobranca: {
        type: "component",
        value: (
          <h3
            style={{
              marginTop: 20,
              marginBot: 10,
              textDecoration: "underline",
            }}
          >
            Parâmetros de cobrança
          </h3>
        ),
      },
      taxaBoleto: {
        label: "Taxa de cobrança via boleto",
        type: "number",
        value: escola.taxaBoleto,
        space: 6,
      },
      taxaCartao: {
        label: "Taxa de cobranca via cartão",
        type: "number",
        value: escola.taxaCartao,
        space: 6,
      },
      tituloConfiguracoesAcesso: {
        type: "component",
        value: (
          <h3
            style={{
              marginTop: 20,
              marginBot: 10,
              textDecoration: "underline",
            }}
          >
            Configurações de acesso
          </h3>
        ),
      },
      inativacao: {
        label: "Inativação de acesso a partir de",
        type: "date",
        value: escola.inativacao,
      },
    },
    submit: {
      label: "salvar",
      action: salvar,
    },
    close: true,
    history: props.history,
  };

  const importarInstituicao = () => {
    cfe
      .post("admin/instituicoes/importarEscolaPerto", {
        escolaId: instituicaoImportar.id,
      })
      .then(() => {
        notification("success", "Instituição importada com sucesso.");
        setEscolas([]);
        setEscola({});
        setInstituicaoImportar({});
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao importar a instituição.");
      });
  };

  const fInstituicaoImportar = {
    title: "Instituição a incluir",
    form: {
      nomeFantasia: {
        type: "component",
        value: (
          <>
            <h4>Nome fantsia</h4>
            <p>{instituicaoImportar.nomeFantasia}</p>
          </>
        ),
        space: 6,
      },
      local: {
        type: "component",
        value: (
          <>
            <h4>Local</h4>
            <p>{instituicaoImportar.local}</p>
          </>
        ),
        space: 6,
      },
    },
    submit: {
      label: "Confirmar inclusão",
      action: importarInstituicao,
    },
    close: {
      label: "Cancelar",
      action: () => setInstituicaoImportar({}),
    },
  };

  const tResultadoBuscaEscolas = {
    title: "Escolas localizadas",
    array: escolas,
    onLineClick: (instituicaoImportar) =>
      setInstituicaoImportar(instituicaoImportar),
    columns: [
      {
        name: "nomeFantasia",
        label: "Nome fantasia",
      },
      {
        name: "local",
        label: "Local",
      },
    ],
  };

  return (
    <div>
      {instituicaoId > 0 ? (
        <Form formData={fInstituicao} />
      ) : (
        <>
          <Form formData={fBuscaEscola} />
          {instituicaoImportar.id ? (
            <Form formData={fInstituicaoImportar} />
          ) : (
            <ActionTable structure={tResultadoBuscaEscolas} />
          )}
        </>
      )}
    </div>
  );
}
